/*
 *   File : forgot-password.js
 *   Author : https://evoqins.com
 *   Description :Forgot password page of rayi
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";

// custom components
import { CustomTextInput, OTPInput } from '../../Components/FormElements';
import { PrimaryButton } from "../../Components/Buttons";
import { Icon } from '../../Components/Icon';

// custom style 
import style from "../../Style/Component/auth.module.scss";
import { APIService } from '../../Service';
import { toast } from 'react-toastify';

const ForgotPassword = () => {

    const inputRef = useRef(null);
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");

    const [forgotFlow, setForgotFlow] = useState(1);

    const [otpValue, setOtpValue] = useState("");
    const [otpValueError, setOtpValueError] = useState("");
    const [focusedInput, setFocusedInput] = useState(2);
    const [seconds, setSeconds] = useState(30);
    const [timerActive, setTimerActive] = useState(false);
    const [newPassword, setNewPassword] = useState("");
    const [newPasswordError, setNewPasswordError] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
    const [loader, setLoader] = useState(false);
    const [tempToken, setTempToken] = useState("");

    useEffect(() => {
        setEmailError("");
    }, [email]);

    useEffect(() => {
        setOtpValueError("");
    }, [otpValue]);

    useEffect(() => {
        setNewPasswordError("");
    }, [newPassword]);

    useEffect(() => {
        setConfirmPasswordError("");
    }, [confirmPassword]);

    useEffect(() => {
        let timer;
        if (timerActive && seconds > 0) {
            timer = setInterval(() => {
                setSeconds((prev) => prev - 1);
            }, 1000);
        } else if (seconds === 0) {
            setTimerActive(false);
            setSeconds(30);
        }

        return () => clearInterval(timer);
    }, [timerActive, seconds]);

    // handle next step  
    const _handleContinue = () => {
        let is_valid = true;
        let validate_email = /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;

        if (email.trim().length === 0) {
            setEmailError("Enter your email address");
            is_valid = false;
        } else if (!validate_email.test(email)) {
            setEmailError("Enter a valid email address");
            is_valid = false;
        }

        if (is_valid === true) {
            _forgotPassword();
        }
    };

    // handle back
    const _handleBack = (type) => {
        if (type === 1) {
            navigate("/");
        } else if (type === 2) {
            setForgotFlow(1);
            setOtpValue("");
            setOtpValueError("");
            setFocusedInput(2);
            setTimerActive(false);
            setSeconds(30);
        } else {
            navigate("/");
        }
    };

    //handle Otp change
    const _handleChangeOTP = (value) => {
        setOtpValue(value);
    };

    // handle resend OTP 
    const _handleResendOtp = () => {
        setOtpValue("");
        setFocusedInput(2);
        setTimerActive(true);
        setSeconds(30);
    };

    // handle verify otp
    const _handleVerify = () => {
        let is_valid = true;
        if (otpValue.length < 4) {
            setOtpValueError("Please enter received OTP");
            is_valid = false;
        }

        if (is_valid === true) {
            _handleVerifyOtp();
        }
    };

    // handle change pw submit
    const _handleSubmit = () => {
        let is_valid = true;
        let validate_new_password = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

        if (newPassword.trim().length === 0) {
            setNewPasswordError("Enter a new password");
            is_valid = false;
        } else if (!validate_new_password.test(newPassword)) {
            setNewPasswordError("Please provide a valid password");
            is_valid = false;
        }

        if (confirmPassword.trim().length === 0) {
            setConfirmPasswordError("Re-enter the password");
            is_valid = false;
        }

        if (newPassword !== confirmPassword) {
            setConfirmPasswordError("Password does not match");
            is_valid = false;
        }

        if (is_valid === true) {
            _resetPassword();
        }
    };


    // API - Forgot password
    const _forgotPassword = () => {
        let is_post = true;
        let url = 'auth/forgot-password';
        let data = {
            // "email": "rayi_superadmin@admin.com"
            "email": email
        }
        setLoader(true);
        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setForgotFlow(2);
                setTimerActive(true);
                // toast.dismiss()
                // toast.success(response.message, {
                //     type: "success"
                // });
            } else {
                toast.dismiss();
                toast.success(response.message, {
                    type: "error"
                });
            }
            setLoader(false);
        });
    };

    // API - Verify OTP - reset password
    const _handleVerifyOtp = () => {
        let is_post = true;
        let url = 'auth/verify-otp';
        // const otpNumber = parseInt(otpValue, 10);
        // Converts OTP to a number
        let data = {
            "username": email,
            "otp": otpValue,
            "type": "RESET_PASSWORD"
        };
        setLoader(true);
        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                const token = response.access_token.temp_token;
                // Cookies.set('access_token', token, {
                //     domain: process.env.REACT_APP_ENV_DOMAIN,
                //     path: '/'
                // });
                setTempToken(token);
                setForgotFlow(3);
            } else {
                toast.dismiss();
                toast.error(response.message, { type: "error" });
            }
            setLoader(false);
        });
    };

    const _resetPassword = () => {
        let is_post = true
        const url = 'auth/reset-password';
        const data = {
            "password": newPassword,
            // "temp_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiY3JlYXRlZCI6IjIwMjUtMDEtMjggMTE6MzU6NDcuNTU2NDMxIiwiZXhwIjoxNzM4MDY1MDQ3LCJ0b2tlbl90eXBlIjoicmVmcmVzaF90b2tlbiJ9.k159FIoaAKspXJxfm1EKs8tf1RPDwKE9XLpItWBPwYA"
            "temp_token": tempToken,
        }
        setLoader(true);
        APIService(is_post, url, data).then((response) => {

            if (response.status_code === 200) {
                navigate("/login");
            } else {
                toast.dismiss();
                toast.success(response.message, { type: "error" });
            }
            setLoader(false);

        });
    };

    return (
        <section className={`${style.e_auth_wrapper} padding-64px-tb position-relative`}>
            <div className='container px-lg-0 px-md-0 px-sm-0 px-3'>
                <div className='text-center d-flex justify-content-center'>
                    <img src={require("../../Assets/Image/logo.svg").default}
                        draggable={false}
                        alt='rayi-logo' />
                </div>
                {/* Back button */}
                {forgotFlow === 3 &&
                    <div className='d-flex gap-1 align-items-center position-absolute right-80px top-90px cursor-pointer'
                        onClick={() => _handleBack(3)}>
                        <Icon icon='back'
                            size="1.25rem"
                            className="d-flex " />
                        <span className='e-text-arsenic e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                            Go back
                        </span>
                    </div>
                }
                <div className='row padding-32px-top'>
                    <div className='offset-lg-4 offset-md-2 offset-sm-2 offset-1 col-lg-4 col-md-8 col-sm-8 col-10 px-lg-0'>
                        <div className={`${style.e_form_wrapper} e-bg-white border-radius-16 padding-40px-all`}>
                            {forgotFlow === 1 ?
                                <>
                                    <Icon icon='back'
                                        size="1.25rem"
                                        className="cursor-pointer"
                                        onClick={() => _handleBack(1)} />
                                    <h3 className='my-4 e-text-chinese-black e-primary-font e-font-24 e-font-weight-700 line-height-28px'>
                                        User Authentication
                                    </h3>

                                    {/* Email */}
                                    <CustomTextInput label="Enter registered email"
                                        placeholder="Enter email"
                                        type="text"
                                        autoFocus={true}
                                        required={true}
                                        value={email}
                                        error={emailError}
                                        className="w-100"
                                        onKeyPress={_handleContinue}
                                        handleChange={(e) => setEmail(e)} />

                                    {/* Login button */}
                                    <div className='margin-22px-top'>
                                        <PrimaryButton name="Confirm"
                                            className="w-100 "
                                            loader={loader}
                                            onClick={_handleContinue} />
                                    </div>
                                </>
                                :

                                // Otp verify section 
                                forgotFlow === 2 ?
                                    <>
                                        <Icon icon='back'
                                            size="1.25rem"
                                            className="cursor-pointer"
                                            onClick={() => _handleBack(2)} />
                                        <h3 className='my-4 e-text-chinese-black e-primary-font e-font-24 e-font-weight-700 line-height-28px'>
                                            OTP Verification
                                        </h3>

                                        {/* OTP input */}
                                        <OTPInput label="Enter otp sent to the mail id"
                                            required={true}
                                            ref={inputRef}
                                            value={otpValue}
                                            spellCheck="false"
                                            error={otpValueError}
                                            focusedInput={focusedInput}
                                            onFocus={() => setFocusedInput(2)}
                                            onBlur={() => setFocusedInput(0)}
                                            onKeyPress={_handleVerify}
                                            onChange={_handleChangeOTP} />
                                        <p className='pt-3 mt-1 mb-0 e-text-taupe-gray  e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                            Didn’t get code yet?
                                            <span className={`${timerActive ? 'pe-none' : ''} ps-1 e-text-blue-violet text-decoration-hover-underline cursor-pointer`}
                                                onClick={_handleResendOtp}>
                                                {timerActive ? `Resend OTP in ${seconds}s` : 'Resend OTP'}
                                            </span>
                                        </p>

                                        {/* Login button */}
                                        <PrimaryButton name="Confirm"
                                            className="w-100 mt-4"
                                            loader={loader}
                                            onClick={_handleVerify} />
                                    </>
                                    :
                                    // Change Password
                                    <>
                                        <h3 className='mb-4 e-text-chinese-black e-primary-font e-font-24 e-font-weight-700 line-height-28px'>
                                            Change Password
                                        </h3>

                                        <div className='d-flex gap-2px align-items-start e-bg-old-lace border-radius-8 p-3 mb-3'>
                                            <Icon icon='info'
                                                size="1.125rem"
                                                className="d-flex " />
                                            <p className='mb-0 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                Your new password must be at least 8 characters long. It should include a mix of uppercase and lowercase letters, numbers, and special characters.
                                            </p>
                                        </div>

                                        {/* New password */}
                                        <CustomTextInput label="Enter new password"
                                            placeholder="Enter password"
                                            type="text"
                                            autoFocus={true}
                                            required={true}
                                            value={newPassword}
                                            error={newPasswordError}
                                            className="w-100"
                                            wrapperClass="mb-3"
                                            onKeyPress={_handleSubmit}
                                            handleChange={(e) => setNewPassword(e)} />

                                        {/* Confirm password */}
                                        <CustomTextInput label="Confirm password"
                                            placeholder="Enter password"
                                            type="text"
                                            required={true}
                                            value={confirmPassword}
                                            error={confirmPasswordError}
                                            className="w-100"
                                            onKeyPress={_handleSubmit}
                                            handleChange={(e) => setConfirmPassword(e)} />

                                        {/* Login button */}
                                        <div className='margin-32px-top'>
                                            <PrimaryButton name="Confirm"
                                                className="w-100 "
                                                loader={loader}
                                                onClick={_handleSubmit} />
                                        </div>
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ForgotPassword;